module.exports = __webpack_public_path__ + "static/media/source-sans-pro-italic.72217712.eot";